import 'babel-polyfill'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import './scss/variables.scss';
import axios from 'axios';
import firebase from "./plugins/firebase";
import {setMetaTag} from '../src/helper/metaTag'
Vue.config.productionTip = false

//#region global hooks
router.beforeEach(async (to, from, next) => {
  const publicComponent = ['login'];
  // let externalAccess = await axios.put(`${store.state.api}/account/logout`, null, store.getters.requestHeaders)
  // let externalAccess = false
  // const host = window.location.host;
  // const parts = host.split(".");
  // let currentUrl = window.location.href;

  // let subDomain = "";
  // if (host.indexOf("localhost") > -1 && parts.length > 1) {
  //   if (parts[0] !== "localhost") {
  //     subDomain = parts[0];
  //   }
  // } else if (parts.length >= 3) {
  //   subDomain = parts[0];
  // }
  // // When have subdomain, separate by sub domain
  // if (subDomain.length > 0 && subDomain !== "localhost") {
  //   await this.$http
  //     .get(
  //       `${this.$store.state.api}/company/detail/subdomain?domainname=${subDomain}`
  //     )
  //     .then(resp => {
  //       console.log(resp);
  //       if (resp.status == 200 && resp.data.status == true) {
  //         externalAccess = resp.data.result.company.externalAccess
  //       }
  //     })
  //     .catch(err => {
  //     });
  // }
  // if (externalAccess == false) {
  //   const user = Vue.$cookies.get('user_token');
  //   // if()

  // }

  ////


  if (publicComponent.findIndex((x) => x === to.name) === -1) {
    // not in public component then check user data
    const user = Vue.$cookies.get('user_token');
    if (to.query.user_token) {
      try {
        // console.log(user, user !== to.query.user_token)
        if (user && user !== to.query.user_token) {
          try {
            await axios.put(`${store.state.api}/account/logout`, null, store.getters.requestHeaders)
          } catch (error) {
            console.log(error)
          }
          // .then(res => {
          // });
        }
        await Vue.$cookies.remove("user_token");
        await Vue.$cookies.remove("user_info");
        await Vue.$cookies.set(
          "user_token",
          to.query.user_token,
          // resp.data.result.endTime
        );
        await axios.get(`${store.state.api}/account/tula/info`).then(resp => {
          if (resp.status == 200 && resp.data.status == true) {
            const info = {
              companies: resp.data.result.info.companies,
              displayName: resp.data.result.info.displayName,
              email: resp.data.result.info.email,
              firstName: resp.data.result.info.firstName,
              image: resp.data.result.info.image,
              isTeacher: resp.data.result.info.isTeacher,
              lastName: resp.data.result.info.lastName,
              _id: resp.data.result.info._id,
              setting: resp.data.result.setting
            };

            // asd

            Vue.prototype.$userInfo = info
            Vue.prototype.$buttonColor = info.companies[0].buttonColor
            Vue.prototype.$themeColor = info.companies[0].themeColor
            setMetaTag(info.companies[0])
            if (info.companies[0].connectToolsWith) {
              setGoogleAnalytic(info.companies[0].connectToolsWith.googleAnalytics);
            }

            // to.query.user_token = null
            let queryWithoutToken = to.query
            delete queryWithoutToken.user_token
            router.replace({
              name: to.name,
              params: to.params,
              query: queryWithoutToken
            });
            // next()
            // this.$router.replace({
            //   name: "home"
            // });
          }
        })
          .catch(err => {
            router.replace({
              name: "login"
            });
          })
          .finally(() => {
            // this.loading = false;
          });

        // let horizontal = [
        //   "banner_slider",
        //   "my_course_vertical_gridview",
        //   "course_vertical_gridview",
        //   "category_horizontal_listview",
        // ];
        // let vertical = [
        //   "teacher_horizontal_listview",
        //   "category_horizontal_listview",
        //   "tag_list",
        //   "grade_horizontal_listview",
        // ];
        // let company = Vue.prototype.$userInfo.companies[0]._id;
        // let settings = Vue.prototype.$userInfo.setting;
        // let item = settings.filter((item) => item.name == "Home");
        // Vue.prototype.$elements = [];
        // await axios.get(
        //   `${store.state.api}/home/V2?index=${item[0].priority}${user ? "" : "&companyID=" + company
        //   }`
        // )
        //   .then((resp) => {
        //     if (resp.status == 200 && resp.data.status == true) {
        //       Vue.prototype.$elements = resp.data.result.elements;

        //       EventBus.$emit("updateNavBar", resp.data.result.navBarTitle);

        //       Vue.prototype.$itemHorizontal = resp.data.result.elements.filter((item) =>
        //         horizontal.includes(item.template)
        //       );
        //       dataVertical = resp.data.result.elements.filter((item) =>
        //         vertical.includes(item.template)
        //       );
        //       dataVertical.forEach((element) => {
        //         Vue.prototype.$itemVertical[element.template] = element;
        //       });
        //       this.$emit("data", Vue.prototype.$itemVertical);
        //     }
        //   })
        //   .catch((err) => { })
        //   .finally(() => {
        //     next();
        //     // this.loading = false;
        //   });
      }
      catch (error) {
        router.replace({
          name: to.name,
          params: to.params,
          query: queryWithoutToken
        });
      }
      // next()
    } else if (user == null) {
      if (window.location.href.indexOf("/login") == -1 && window.location.href.indexOf("/signup") == -1) {
        let fromUrl = {
          path: to.path,
          query: to.query
        }
        localStorage.setItem("fromUrl", JSON.stringify(fromUrl))
      }

      let company = null
      const host = window.location.host;
      const parts = host.split(".");
      let subDomain = "";
      // if (host.indexOf("localhost") > -1 && parts.length > 1) {
      //   if (parts[0] !== "localhost") {
      //     subDomain = parts[0];
      //   } 
      //   else {
      //     next({ name: 'login' });
      //   }
      // }
      // else if(parts[0] == "nerdof"){
      //   next({ name: 'login' });
      // }
      if(host.indexOf("clsedo") > -1){
        subDomain = "clsedo"  //support culionline.com = culionline.nerdof.com
      } else if(host.indexOf("culionline") > -1){
        subDomain = "culionline"  //support culionline.com = culionline.nerdof.com
      } else if ((parts[0] == 'nerdof' || parts[0] == 'beta' || parts[0] == 'www' || parts[0] == 'home' || parts[0] == 'app' || (parts.length == 2 && host.indexOf("localhost") == -1)) && host.indexOf("vknows") == -1) { // www.nerdof.com, nerdof.com, vknows.co , subdomain.com
        next({ name: 'login' });
      } else if (parts.length >= 3) {  // subdomain.nerdof.com, subdomain.vknows.com
        subDomain = parts[0];
      } else if (host.indexOf("localhost") > -1 && parts.length > 1 && parts[0] !== "localhost") {  // subdimain.localhost
        subDomain = parts[0];
      } else {
        next({ name: 'login' }); //localhost
      }
      // else 
      // if (parts.length >= 3) {   // subdomain.nerdof.com
      //   subDomain = parts[0];
      // }
      // if (parts.length >= 2) {  // nerdof.com, subdomain.com
      //   subDomain = parts[0];
      // }
      // console.log(subDomain)
      // When have subdomain, separate by sub domain
      if (subDomain.length > 0) {
        // await this.$http
        //   .get(
        //     `${$store.state.api}/company/detail/subdomain?domainname=${subDomain}`
        //   )
        //   .then(resp => {
        //     console.log(resp);
        //     if (resp.status == 200 && resp.data.status == true) {
        //       company.externalAccess = resp.data.result.company.company.externalAccess
        //     }
        //   })
        //   .catch(err => {
        //   });
        await axios.get(`${store.state.api}/company/detail/subdomain?domainname=${subDomain}`).then(resp => {
          if (resp.status == 200 && resp.data.status == true) {
            company = resp.data.result.company
            let setting = resp.data.result.setting

            setMetaTag(resp.data.result.company)
            // if(!company){
            //   window.location.href="https://nerdof.com/login"
            // } else
            
            if (to.name == 'register' && !company.canRegister) { // don't have register permisison.
              next({ name: 'login' })
            } else if (to.name == 'register') {
              next()
            } else if (company.externalAccess == false) {  // not public company.
              next({ name: 'login' });
            } else {
              let user_info = {
                companies: [
                  company
                ],
                setting
              }
              // Vue.$cookies.set("user_info", user_info);
              Vue.prototype.$userInfo = user_info
              Vue.prototype.$buttonColor = user_info.companies[0].buttonColor
              Vue.prototype.$themeColor = user_info.companies[0].themeColor
              console.log(user_info.companies[0].connectToolsWith)

              if (user_info.companies[0].connectToolsWith) {
                setGoogleAnalytic(user_info.companies[0].connectToolsWith.googleAnalytics);
              }
              next();
            }
          } else {
            if (window.location.host.indexOf("localhost") > -1) {
              window.location.href = window.location.protocol + "//localhost" + ":" + window.location.port + "/login";
            } else {
              window.location.href = window.location.protocol + "//"+ "app." + parts[1] + "." + parts[2] + "/login";
            }
          }
        })
          .catch(err => {
            router.replace({
              name: "login"
            });
          })
      }
      // if(!company){
      //   window.location.href="https://nerdof.com/login"
      // } else
      // if (company.externalAccess == false) {
      //   next({ name: 'login' });
      // } else {
      //   let user_info={
      //     companies: [
      //       company
      //     ]
      //   }
      //   Vue.$cookies.set("user_info", user_info);
      //   next();
      // }
    } else {
      if (!Vue.prototype.$userInfo) {
        await axios
          .get(`${store.state.api}/account/tula/info`)
          .then(resp => {
            if (resp.status == 200 && resp.data.status == true) {
              const info = {
                companies: resp.data.result.info.companies,
                displayName: resp.data.result.info.displayName,
                email: resp.data.result.info.email,
                firstName: resp.data.result.info.firstName,
                image: resp.data.result.info.image,
                isTeacher: resp.data.result.info.isTeacher,
                lastName: resp.data.result.info.lastName,
                _id: resp.data.result.info._id,
                setting: resp.data.result.setting
              };
              // nearestWithMeta.meta.metaTags.map(tagDef => {
              //   const tag = document.createElement('meta');
            
              //   Object.keys(tagDef).forEach(key => {
              //     tag.setAttribute(key, tagDef[key]);
              //   });
            
              //   // We use this to track which meta tags we create so we don't interfere with other ones.
              //   tag.setAttribute('data-vue-router-controlled', '');
            
              //   return tag;
              // })
              // // Add the meta tags to the document head.
              // .forEach(tag => document.head.appendChild(tag));

              setMetaTag(info.companies[0])
              Vue.prototype.$userInfo = info
              Vue.prototype.$buttonColor = info.companies[0].buttonColor
              Vue.prototype.$themeColor = info.companies[0].themeColor
              console.log(info.companies[0].connectToolsWith)
              if (info.companies[0].connectToolsWith) {
                setGoogleAnalytic(info.companies[0].connectToolsWith.googleAnalytics);
              }
            }
          })
          .catch(err => { })
          .finally(() => {
            next();
          });

        // let horizontal = [
        //   "banner_slider",
        //   "my_course_vertical_gridview",
        //   "course_vertical_gridview",
        //   "category_horizontal_listview",
        // ];
        // let vertical = [
        //   "teacher_horizontal_listview",
        //   "category_horizontal_listview",
        //   "tag_list",
        //   "grade_horizontal_listview",
        // ];
        // console.log(Vue.prototype.$userInfo)
        // let company = Vue.prototype.$userInfo.companies[0]._id;
        // let settings = Vue.prototype.$userInfo.setting;
        // let item = settings.filter((item) => item.name == "Home");
        // Vue.prototype.$elements = [];
        // await axios.get(
        //   `${store.state.api}/home/V2?index=${item[0].priority}${user ? "" : "&companyID=" + company
        //   }`
        // )
        //   .then((resp) => {
        //     if (resp.status == 200 && resp.data.status == true) {
        //       Vue.prototype.$elements = resp.data.result.elements;

        //       EventBus.$emit("updateNavBar", resp.data.result.navBarTitle);

        //       Vue.prototype.$itemHorizontal = resp.data.result.elements.filter((item) =>
        //         horizontal.includes(item.template)
        //       );
        //       dataVertical = resp.data.result.elements.filter((item) =>
        //         vertical.includes(item.template)
        //       );
        //       dataVertical.forEach((element) => {
        //         Vue.prototype.$itemVertical[element.template] = element;
        //       });
        //       this.$emit("data", Vue.prototype.$itemVertical);
        //     }
        //   })
        //   .catch((err) => { })
        //   .finally(() => {
        //     next();
        //     // this.loading = false;
        //   });

      } else {
        setMetaTag(Vue.prototype.$userInfo.companies[0])
        next();
      }
    }
  } else {
    // public component
    next();
  }

  if (to.name != "classroom" && to.name != "live") {
    var database = firebase.database();
    // const userInfo = Vue.$cookies.get('user_info');
    const userInfo = Vue.prototype.$userInfo
    const token = Vue.$cookies.get('user_token');

    if (userInfo) {
      database.ref("/onlineUser").child("user_" + userInfo._id).child(token).remove();
    }
  }
});
// router.onReady(() => {
//   window.ga=window.ga||function(){(ga.q=ga.q||[]).push(arguments)};ga.l=+new Date

//   // Trace debugging
//   // https://developers.google.com/analytics/devguides/collection/analyticsjs/debugging
//   // window.ga_debug = {trace: true}

//   ga('create', 'UA-119467979-1','auto')

//   if (isLocalhost) {
//     ga('set', 'sendHitTask', null)
//   }

//   router.afterEach((to, from) => {
//     ga('set', 'page', to.fullPath)
//     ga('send', 'pageview')
//   })
// })
router.onReady(() => {
  (function (i, s, o, g, r, a, m) {
    i['GoogleAnalyticsObject'] = r; i[r] = i[r] || function () {
      (i[r].q = i[r].q || []).push(arguments)
    }, i[r].l = 1 * new Date(); a = s.createElement(o),
      m = s.getElementsByTagName(o)[0]; a.async = 1; a.src = g; m.parentNode.insertBefore(a, m)
  })(window, document, 'script', `https://www.google-analytics.com/analytics.js`, 'ga')

  ga('create', 'UA-119467979-1', 'auto')

  // Prevent any hits from being sent to Google Analytics
  if (isLocalhost) {
    ga('set', 'sendHitTask', null)
  }

  router.afterEach((to, from) => {
    ga('set', 'page', to.fullPath)
    ga('send', 'pageview')
  })
})
//#endregion
// function setMetaTag(company){
//   // const tag = document.createElement('meta')
//   // tag.setAttribute('title', info.companies[0].slugName)
//   // document.head.appendChild(tag)
//   document.title = company.slugName
//   var link = document.querySelector("link[rel~='icon']");
//   if (!link) {
//       link = document.createElement('link');
//       link.rel = 'image/gif/png';
//       document.getElementsByTagName('head')[0].appendChild(link);
//   }
//   link.href = company.logo;
// }
const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
  // [::1] is the IPv6 localhost address.
  window.location.hostname === '[::1]' ||
  // 127.0.0.1/8 is considered localhost for IPv4.
  window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/)
)
function setGoogleAnalytic(id) {
  if (id) {
    window.ga = window.ga || function () { (ga.q = ga.q || []).push(arguments) }; ga.l = +new Date
    // Trace debugging
    // https://developers.google.com/analytics/devguides/collection/analyticsjs/debugging
    // window.ga_debug = {trace: true}        
    ga('create', id, 'auto')
    // if (isLocalhost) {
    //   ga('set', 'sendHitTask', null)
    // }
  }
}


new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
